const question2 = {
    'question': 'Kiedy warto udać się po pomoc do terapeuty rodzin?',
    'answer': 'Decyzja o podjęciu terapii rodzinnej jest osobistą decyzją, którą każdy członek rodziny musi podjąć samodzielnie. Jeśli jednak zastanawiacie się nad tym, czy terapia może być pomocna w Waszej rodzinie, warto skontaktować się z terapeutą i porozmawiać o swoich potrzebach.'
}

export default question2;